export interface BcmDropDownItem {
    id: number;
    text: string;
}

export enum BcmPeriod {
    ThisMonth = 0,
    LastMonth = 1
}

export interface BcmFilter {
    period: BcmPeriod;

    useCustomRange: boolean;

    fromDate: string | null;

    toDate: string | null;

    teamCodes: number[];
}

export interface BcmFilterOptions {
    periods: BcmDropDownItem[];

    teams: BcmDropDownItem[];

    serverBuiltAt: string | null;
    minDate: string | null;
    maxDate: string | null;
    defaultFrom: string | null;
    defaultTo: string | null;
}

export interface BcmPeriodInfo {
    name: string;
    label: string;
    start: string;

    end: string;
    isCustomRange: boolean;
}

export interface BcmSummary {
    period: BcmPeriodInfo;

    contracts: number;

    feesCollected: number;
}

export interface BcmCategoryRow {
    label: string | null;
    contracts: number;
}

export interface BcmCollectedFees {
    total: number;
    contracts: number;

    average: number;
}

export interface BcmBreakdowns {
    period: BcmPeriodInfo;
    byAgent: BcmCategoryRow[];
    byStatus: BcmCategoryRow[];
    bySite: BcmCategoryRow[];
    collectedFees: BcmCollectedFees;
}

export interface BcmChartPoint {
    label: string;
    date: string;
    value: number;
}

export interface BcmCharts {
    period: BcmPeriodInfo;
    monthlyFees: BcmChartPoint[];
    totalSales: BcmChartPoint[];

    totalSalesGrain: string;
}

export interface BcmCount {
    key: string;
    count: number;
}

export interface BcmClubRollup {
    clubId: number;

    contracts: number;

    feesBilled: number;

    contractsAllTime: number;

    teamCodes: number[];
}

export interface BcmDiagnostics {
    objectPrefix: string;
    rowsContracts: number;
    rowsTotalFees: number;
    rowsPayments: number;
    rowsSites: number;
    rowsStatuses: number;
    minContractDate: string | null;
    maxContractDate: string | null;
    contractsWithNoDate: number;
    window: BcmPeriodInfo;
    inWindowUnscoped: number;
    inWindowScoped: number;
    callerUserRole: number;
    callerCompanyId: number;
    callerTeamCode: number;
    callerUserId: number;

    rowScopingMode: string;
    companyPredicateApplied: boolean;
    matchingCompanyOnly: number;
    matchingTeamOnly: number;
    matchingUserOnly: number;
    matchingScope: number;
    companyIds: BcmCount[];
    teamCodes: BcmCount[];

    contractsByClub: BcmClubRollup[];

    clubsNotListed: number;
    contractsByMonth: BcmCount[];

    teamFilter: number[];

    actingIdentity: string;

    engageUserLookup: string | null;

    actingUserProblem: string | null;
    notes: string[];
}

export interface BcmDashboard {
    period: BcmPeriodInfo;
    summary: BcmSummary;
    breakdowns: BcmBreakdowns;
    charts: BcmCharts;
}

interface BcmResponseBase {
    statusCode: number;
    errorMsg?: string;
}

export interface BcmFilterOptionsResponse extends BcmResponseBase { options: BcmFilterOptions; }
export interface BcmSummaryResponse extends BcmResponseBase { summary: BcmSummary; }
export interface BcmBreakdownsResponse extends BcmResponseBase { breakdowns: BcmBreakdowns; }
export interface BcmChartsResponse extends BcmResponseBase { charts: BcmCharts; }
export interface BcmDashboardResponse extends BcmResponseBase { dashboard: BcmDashboard; }
export interface BcmDiagnosticsResponse extends BcmResponseBase { diagnostics: BcmDiagnostics; }

export function createDefaultBcmFilter(): BcmFilter {
    return {
        period: BcmPeriod.LastMonth,
        useCustomRange: false,
        fromDate: null,
        toDate: null,
        teamCodes: []
    };
}
